import React, { Component } from 'react'
import {NavBar, Icon, Toast} from 'antd-mobile';
import {parseStateToSearch, parseSearchToState} from '../../util/util.js';
import {Http} from '../../api/index';
import NavBarComponent from '../../component/common/NavBarComponent';
import { connect } from 'react-redux';
import { orderCouponAdd } from '../../redux/actions/orderAction'
import './couponList.scss';

class couponList extends Component {
    constructor(props) {
        super(props);
        props.cacheLifecycles.didCache(()=>{this.componentDidCache()})
        props.cacheLifecycles.didRecover(() => {this.componentDidRecover()})
        this.param = this.props.location.query || {}
        this.state = {
            loading: false,
            isUseCoupont: false,
            fromtype : 'order',//order 订单  mine 我的
            couponList: []
        };
    }
    componentDidCache(){
      
    }
    componentDidRecover(){
      this.setState({
        couponList: []
      })
      this.getList()
    }
    componentDidMount = () => { 
       this.getList()
    }
    getList() {
      this.setState(() => {
        Toast.loading('Loading...');
        return {loading: true};
      });
      const {location} = this.props;
      const search = location.search || {};
    
      let parmData;
      parmData = parseSearchToState(decodeURIComponent(search))
      const {
          orderSnapshotId,
          total,
          priceItemsJson,
          tenancy,
          productType,
          storeId,
          modelId,
          paymentType,
          type
      } = parmData
      let url;
      let data ={}
      if(type === "order"){
          this.setState({
              fromtype: 'order'
          });
          url = '/api/coupon/query/availableCouponList.json'
          data ={
              total: total,
              priceItemsJson:priceItemsJson,
              tenancy: tenancy,
              productType: productType,
              storeId: storeId,
              modelId: modelId,
              paymentType: paymentType,
              orderSnapshotId : orderSnapshotId
          }
      }else {
          this.setState({
              fromtype: 'mine'
          });
          url = '/api/coupon/query/couponList.json';
          data = {}
      }
      Http.post({url, data: data}).then(res => {
          let chooseLength;
          let priorityIndex; 
          let chooseItem;
          const couponList = res.data
          couponList.map((item,index) => {
              if(this.props.orderReducer.couponInfo&&this.props.orderReducer.couponInfo.code==item.code){
                  item.ischoose = true
                  chooseLength = 1
                  chooseItem = item
              }
              if(item.priority == '1'){
                  priorityIndex = index
              }
          })
          if(chooseLength !== 1 && priorityIndex != undefined){
              couponList[priorityIndex].ischoose = true
              chooseItem = couponList[priorityIndex]
          }
          this.props.dispatch(orderCouponAdd(chooseItem))
          this.setState(() => {
              Toast.hide();
              return {
                  couponList,
                  loading: false
              };
          });
      });
    }
    //去使用说明
    gotUseInstruction = (data) => {
        const {history} = this.props;
        let newData = {
            type : this.state.fromtype
        }
        Object.assign(newData, data);
        history.push({
            pathname: '/couponInstructions',
            search: parseStateToSearch(newData)
        });
    }
    //选择优惠券
    chooseCoupon = (item,indexCode) => {
        this.props.dispatch(orderCouponAdd(item))
        let oldList = this.state.couponList
            oldList[indexCode].ischoose = !oldList[indexCode].ischoose
        let newList = []
        for(let n = 0; n < oldList.length; n++ ){
            if(indexCode != n){
                oldList[n].ischoose = false
            }
            newList.push(oldList[n])
        }

        this.setState({
            couponList:newList
        });
        this.props.history.goBack()
    }
    //是否使用优惠券
    changeIsUseCoupont = (code) => {
        if(!code){
            this.props.dispatch(orderCouponAdd({}))
        }
        this.setState({
            isUseCoupont:!code
        })
        let oldList = this.state.couponList
        let newList = []
        for(let n = 0; n < oldList.length; n++ ){
            oldList[n].ischoose = false
            newList.push(oldList[n])
        }
        this.setState({
            couponList:newList
        });
    }
    render() {
        return <div id='coupon' className={this.state.isUseCoupont?"coupon page  nouse":"coupon page"} >
            <div className="coupon-top">
                <NavBarComponent>
                    <NavBar
                        icon={<Icon type="left" color='#333' />}
                        mode="light" 
                        onLeftClick={ () => this.props.history.goBack() }
                        >
                        选择优惠券
                    </NavBar>
                </NavBarComponent>
            </div>
            {/* <div className="coupon-list">
                <div className="exchange">兑换</div>
            </div> */}
            {
                this.state.fromtype == 'order'?
                <div className='nousecoupon'>
                    <span>不使用优惠券</span>
                    <span className="usechoose-icon" onClick={() => this.changeIsUseCoupont(this.state.isUseCoupont)}>
                        {
                            this.state.isUseCoupont?
                                <Icon type="check-circle" size="xs" color="red"  />
                            :
                                <Icon type="check-circle" size="xs" color="#c3c3c3" />
                        }
                    </span>
                </div>
                :null
            }
            
            <div  className="coupon-list">
                {
                    this.state.couponList.map((item,index) =>(
                        <div  className="coupont-item" key={item.code} >
                            <div  className={item.enable == 0?"img-left nouse":"img-left"}  >
                                {
                                    item.ruleType == 1?
                                        <span className="discount">¥{item.amount}</span>
                                    :null
                                }
                                {
                                    item.ruleType == 2?
                                         <span className="discount">{item.amount}天</span>
                                    :null
                                }
                                {
                                    item.ruleType == 3?
                                        <span className="discount">{item.amount}折</span>
                                    :null 
                                }
                                <span className="conditions">{item.threshold}</span> 
                            </div>
                            <div className="text-right">
                                <div className="item-title">
                                    <span className={this.state.fromtype == 'order'?"name":"name maxwidth"} >{item.name}</span>
                                    {
                                        this.state.fromtype == 'order' && item.enable != 0? 
                                            <span className="item-choose" onClick={() => this.chooseCoupon(item,index)}>
                                                {
                                                    item.ischoose?
                                                        <Icon type="check-circle" size="xs" color="red" />
                                                    :   
                                                        <Icon type="check-circle" size="xs" color="#c3c3c3" />
                                                }
                                            </span>
                                        :null
                                    }
                                </div>
                                <div className="itme-time">
                                    <span className="time">{item.effectiveTerm}</span>
                                </div>
                                <div className="itme-to-details" onClick={() => this.gotUseInstruction(item)}>
                                    <span className="use-instructions">使用说明</span>
                                    <span className="use-instructions-icon">
                                        <Icon type="right" size="xs" color="#c3c3c3" />
                                    </span>
                                </div>
                            </div>
                            {
                                item.enable == 0?
                                    <div className="unusableReason">
                                        <div className="tip">
                                            <span className="warning-icon">
                                                <img src={require('../../static/images/warning.png')} />
                                            </span>
                                            <span className="warning-text">不可用原因</span>
                                        </div>
                                        <div className="unusableReason-text">
                                            {item.unusableReason}
                                        </div>
                                    </div>
                                :null
                            }
                        </div>
                    ))
                }
                <div className="nomorelist">
                    <span className="left-line"></span>
                    <span className="center-text">已加载所有优惠券</span>
                    <span className="right-line"></span>
                </div>
            </div>
            
        </div>
    }
}
const mapState =  connect(state => {
  const { orderReducer } = state
  return { orderReducer }
});
export default mapState(couponList);